<!--Questions-->
<!--Add Aircraft Form - what is required vs optional? Use other form component? DB updates?-->
<!--TODO Don't use anything that requires a DB change, look at old form.-->
<!--Aircraft Details - what calculates next maintenance due? What makes the green plane indicators change on the insp&maint overview?
 How are those calculations made? What do the view and update buttons do? Where should edit button go? Squawk tiles are a little confusing by only listing one user -->
<!--Add Squawk Form - what is required vs optional? Use other form component? DB updates?-->
<!--TODO Don't use anything that requires a DB change, look at old form.-->

<template>
  <div :class="$style.pageContainer">
    <!--    <div :class="$style.dataTileContainer">-->
    <!--      <div :class="$style.dataTile">-->
    <!--        <div :class="$style.dataTileLabel">Assets Available</div>-->
    <!--        <div :class="$style.dataDisplay">-->
    <!--          <b :class="$style.dataTileLabel">17</b>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div :class="$style.dataTile">-->
    <!--        <div :class="$style.dataTileLabel">Assets Grounded</div>-->
    <!--        <div :class="$style.dataDisplay">-->
    <!--          <b :class="$style.dataTileLabel">1</b>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div :class="$style.dataTile">-->
    <!--        <div :class="$style.dataTileLabel">Total Squawks</div>-->
    <!--        <div :class="$style.dataDisplay">-->
    <!--          <b :class="$style.dataTileLabel">3</b>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div :class="$style.dataTile">-->
    <!--        <div :class="$style.dataTileLabel">Upcoming Maintenance</div>-->
    <!--        <div :class="$style.dataDisplay">-->
    <!--          <b :class="$style.dataTileLabel">5</b>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div :class="$style.aircraftTileDisplay">
      <div
        :class="$style.aircraftTileDisplayHeader"
        @click="openAddAircraftOverlay"
      >
        <b :class="$style.aircraftTileDisplayLabel">Aircraft and Sims</b>
        <div :class="$style.addAircraftContainer">
          <div :class="$style.addAircraftButton">Add Aircraft</div>
          <img
            :class="$style.addButtonIcon"
            alt=""
            src="/static/img/white_plus.svg"
          />
        </div>
      </div>
      <div :class="$style.aircraftTileContainer">
        <div v-for="plane in aircrafts" :key="'instructor-row-' + plane.id">
          <AircraftTile
            @tile-clicked="handleTileClicked(plane)"
            :aircraft="plane"
          />
        </div>
      </div>
    </div>
    <!--    <div :class="$style.frameItem" />-->
    <AddEditAircraft
      @close="closeAddAircraftOverlay"
      @save="saveNewAircraft"
      :aircraft="null"
      :isVisible="isVisible"
    />
  </div>
</template>
<script>
import AddEditAircraft from "./Aircraft/AddEditAircraft.vue";
import AircraftTile from "./Aircraft/AircraftTile.vue";
import AircraftAPIService from "@/servicehandlers/AircraftAPIService";
import { useLoginStore } from "@/stores/loginStore";
import { getProcessedImageUrl } from "@/util/images";
const aircraftAPIService = new AircraftAPIService();

export default {
  name: "Aircraft",
  components: { AddEditAircraft, AircraftTile },
  props: {
    aircraft: null,
    openEdit: null,
  },
  data() {
    return {
      isVisible: false,
      currentUser: {},
      aircrafts: [],
    };
  },
  async mounted() {
    const user = useLoginStore().getUser;
    this.currentUser = {
      userId: user.id,
      userName: `${user.firstName} ${user.lastName}`,
      userType: user.userType?.name,
    };
    if (useLoginStore().isAdmin) {
    }
    await Promise.all([this.getAircraft()]);
  },
  //beforeMount() {},
  //computed: {},
  methods: {
    // GETTERS
    async getAircraft() {
      return aircraftAPIService
        .get(this.$router)
        .then((response) => {
          this.aircrafts = response.map((item) => {
            return {
              ...item,
              aircraftStatus: item.aircraftStatus?.name,
              name: `${item.tailNumber} ${item.model}`,
              image: getProcessedImageUrl(item.image),
            };
          });
        })
        .catch(() => {});
    },

    //ON-CLICKS
    openAddAircraftOverlay() {
      this.isVisible = true;
    },
    closeAddAircraftOverlay() {
      this.isVisible = false;
    },
    saveNewAircraft() {
      this.getAircraft();
      this.closeAddAircraftOverlay();
    },
    handleTileClicked(selectedAircraft) {
      //TODO Send real ID or plane object
      const aircraft = this.aircrafts.find(
        (plane) => plane.id === selectedAircraft.id,
      );
      this.$router.push({ path: `/hilo/aircraft/details/${aircraft.id}` });
    },
  },
}
</script>
<style module scoped>
.addAircraftButton {
  position: relative;
  line-height: 25px;
}
.dataTileLabel {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dataDisplay {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}
.dataTile {
  align-self: stretch;
  flex: 1;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  gap: 10px;
}
.dataTileContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 50px;
  gap: 40px;
  z-index: 2;
  font-size: 15px;
}
.aircraftTileDisplayLabel {
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addButtonIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
}
.addAircraftContainer {
  border-radius: 5px;
  background-color: #3c78ff;
  height: 29px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
  box-sizing: border-box;
  gap: 5px;
  text-align: center;
  font-size: 18px;
  color: #fff;
}
.aircraftTileDisplayHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

.aircraftTileContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 35px;
  gap: 40px;
}
.aircraftTileDisplay {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 25px;
  z-index: 1;
  font-size: 40px;
}

.pageContainer {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
